import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AHBAHerding {
  const ahbaStockOptions = [
    { value: "None", id: "None" },
    { value: Constants.dog_class_section.sheep, id: Constants.dog_class_section.sheep },
    { value: Constants.dog_class_section.cattle, id: Constants.dog_class_section.cattle },
    { value: Constants.dog_class_section.ducks, id: Constants.dog_class_section.ducks },
    { value: Constants.dog_class_section.goats, id: Constants.dog_class_section.goats },
    { value: Constants.dog_class_section.geese, id: Constants.dog_class_section.geese },
    { value: Constants.dog_class_section.turkeys, id: Constants.dog_class_section.turkeys },
    { value: Constants.dog_class_section.mixed_stock, id: Constants.dog_class_section.mixed_stock },
  ];

  const ahbaLevelOptions = [
    { value: "None", id: "None" },
    { value: Constants.dog_class_element_level.ahba_level_i, id: Constants.dog_class_element_level.ahba_level_i },
    { value: Constants.dog_class_element_level.ahba_level_ii, id: Constants.dog_class_element_level.ahba_level_ii },
    { value: Constants.dog_class_element_level.ahba_level_iii, id: Constants.dog_class_element_level.ahba_level_iii },
  ];

  const makeCompetitiveRow = (element: string): IEventRegisterRow => ({
    allowDuplicates: true,
    inputs: [
      {
        elementType: "level",
        type: "dropdown",
        flex: 2,
        label: element,
        options: ahbaLevelOptions,
      },
      {
        elementType: "section",
        showElement: element,
        type: "dropdown",
        defaultValue: "None",
        label: "Stock",
        options: ahbaStockOptions,
      },
    ],
  });

  const makeTestRow = (element: string): IEventRegisterRow => ({
    allowDuplicates: true,
    inputs: [
      {
        elementType: "section",
        showElement: element,
        type: "dropdown",
        flex: 2,
        defaultValue: "None",
        label: element,
        options: ahbaStockOptions,
      },
    ],
  });

  export const form: IEventRegisterRow[] = [
    makeCompetitiveRow(Constants.dog_class_element.ahba_htd),
    makeCompetitiveRow(Constants.dog_class_element.ahba_htad),
    makeCompetitiveRow(Constants.dog_class_element.ahba_hrd),
    makeCompetitiveRow(Constants.dog_class_element.ahba_rlf),
    makeCompetitiveRow(Constants.dog_class_element.ahba_btd),
    makeTestRow(Constants.dog_class_element.ahba_jhd),
    makeTestRow(Constants.dog_class_element.ahba_hct),
  ];
}
